import React from 'react'
import { Outlet } from 'react-router-dom'

function SharelinkLayout() {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default SharelinkLayout
